import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import MainLayout from './layouts/MainLayout'
import Dashboard from './pages/Dashboard'
import Products from './pages/Products'
import PriceManagement from './pages/Products/PriceManagement'
import ProductCertManagement from './pages/Products/ProductCertManagement'
import Orders from './pages/Orders'
import Users from './pages/Users'
import Coupons from './pages/Coupons'
import Statistics from './pages/Statistics'
import HomeConfig from './pages/Settings/HomeConfig'
import DeliveryConfig from './pages/Settings/DeliveryConfig'
import AdminManagement from './pages/Settings/AdminManagement'
import CompanyCertManagement from './pages/Settings/CompanyCertManagement'
import OperationLogs from './pages/Settings/OperationLogs'
import DataBackup from './pages/Settings/DataBackup'
import ProtectedRoute from './components/ProtectedRoute'
import { flushPendingLogs } from './utils/operationLog'
import { useEffect } from 'react'
import './App.css'

function App() {
  // 应用启动时，尝试重发本地缓存的操作日志
  useEffect(() => {
    // 延迟执行，避免与 ProtectedRoute 认证检查竞争
    const timer = setTimeout(() => {
      flushPendingLogs().catch(() => {
        // 静默失败
      })
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        {/* 登录页 - 公开路由 */}
        <Route path="/login" element={<Login />} />

        {/* 需要登录的路由 - 使用 ProtectedRoute 包裹 */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="products/price" element={<PriceManagement />} />
          <Route path="products/certs" element={<ProductCertManagement />} />
          <Route path="orders" element={<Orders />} />
          <Route path="users" element={<Users />} />
          <Route path="coupons" element={<Coupons />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="settings/home" element={<HomeConfig />} />
          <Route path="settings/delivery" element={<DeliveryConfig />} />
          <Route path="settings/admin" element={<AdminManagement />} />
          <Route path="settings/certs" element={<CompanyCertManagement />} />
          <Route path="settings/logs" element={<OperationLogs />} />
          <Route path="settings/backup" element={<DataBackup />} />
        </Route>

        {/* 404 重定向到首页 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
